module.exports = __webpack_public_path__ + "static/media/gift07_zhCht.f6810ae9.png";